<template>
    <el-row>
        <template v-if="typeDom">
            <el-col :span="8">
                <el-select
                    :disabled="optType == 'detail'" 
                    v-model="attribute[indexProperty].value_id"
                    placeholder="请选择属性值"
                    style="width: 290px"
                    @change="selectChange"
                >
                    <el-option
                        v-for="item in value"
                        :key="item.value_id" 
                        :label="item.value_name"
                        :value="item.value_id"
                    ></el-option>
                </el-select>
            </el-col>
            <el-col :span="16">
                <template v-if="unitDom == 'n+1'">
                    <el-select 
                        v-model="attribute[indexProperty].unit_id"
                        placeholder="请选择单位"
                        style="width: 130px"
                        :disabled="optType == 'detail'"
                        @change="selectChangeUnit" 
                    >
                        <el-option
                            v-for="item in unit"
                            :key="item.unit_id" 
                            :label="item.unit_name"
                            :value="item.unit_id"
                        ></el-option>
                    </el-select>
                </template>
                <template v-else-if="unitDom == 1">
                    <div>{{unit[0].unit_name}}</div>
                </template>
                <template v-else>
                    <div></div>
                </template>
            </el-col>
        </template>
        <template v-else>
            <el-col :span="8">
                <el-input :disabled="optType == 'detail'"  
                 v-model.number="attribute[indexProperty].value_name" @change="inputChange" style="width: 290px"></el-input>    
            </el-col>
            <el-col :span="16">
                <template v-if="unitDom == 'n+1'">
                    <el-select
                        placeholder="请选择单位"
                        style="width: 130px"
                        :disabled="optType == 'detail'" 
                        v-model="attribute[indexProperty].unit_id"
                        @change="selectChangeUnit"
                    >
                        <el-option
                            v-for="item in unit"
                            :key="item.unit_id" 
                            :label="item.unit_name"
                            :value="item.unit_id"
                        ></el-option>
                    </el-select>
                </template>
                <template v-else-if="unitDom == 1">
                    <div>{{unit[0].unit_name}}</div>
                </template>
                <template v-else>
                    <div></div>
                </template>
            </el-col>
        </template>
    </el-row>
</template>

<script>
export default {
    data () {
        return {
            property_value: '',
            pro_id: '',
            unit_id: '',
            unit_name: '',
        }
    },
    props: {
        value: {},
        unit: {
            type: Array
        },
        property_id: {},
        name: {},
        indexProperty: Number,
        formAttribute: {},
        attribute: {},
        optType: String
    },
    watch: {
        pro_id (value) {
            let index = this.value.data.findIndex(item => {
                return item.value_id == value
            })
            if (index >= 0) {
                this.property_value = this.value.data[index].value_name;
            }
        },
        unitDom (value) {
            if (value == 1) {
                this.unit_id = this.unit[0].unit_id;
                this.unit_name = this.unit[0].unit_name;
            } else if (value == 'none') {
                this.attribute[this.indexProperty].unit_id = '';
                this.attribute[this.indexProperty].unit_name = '';
            }
        }
    },
    computed: {
        typeDom () {
            if (this.value instanceof Array) {
                return true
            } else {
                return false
            }
        },
        unitDom () {
             if (this.unit.length && this.unit.length > 1) {
                return 'n+1';
            } else if (this.unit.length == 1) {  // 只有一项固定
                return 1;
            } else {                        // 没有单位不显示
                return 'none';
            }
        }
    },
    methods: {
        selectChange () {
            let index = this.value.findIndex(item => {
                return item.value_id == this.attribute[this.indexProperty].value_id
            })
            this.attribute[this.indexProperty].value_name = this.value[index].value_name; 
        },
        selectChangeUnit () {
            let index = this.unit.findIndex(item => {
                return item.unit_id == this.attribute[this.indexProperty].unit_id
            })
            this.attribute[this.indexProperty].unit_name = this.unit[index].unit_name; 
        },
        inputChange () {
            this.attribute[this.indexProperty].value_id = '';
        }
    },
    mounted() {
    // const unit=this.unit
      if(this.attribute.length>0){
        this.attribute[this.indexProperty].property_id = this.property_id;
        this.attribute[this.indexProperty].property_name = this.name;
        if (this.optType == 'edit' || this.optType == 'detail') {
          for(let i = 0; i < this.formAttribute.length; i++) {
            for (let index = 0; index < this.attribute.length; index++) {
              if(this.attribute[index].property_name.indexOf(this.formAttribute[i].property_name)!==-1 ){
                  this.attribute[index].id = this.formAttribute[i].id
                  this.attribute[index].property_id = this.formAttribute[i].property_id
                  this.attribute[index].value_name = this.formAttribute[i].value_name 
                  this.attribute[index].value_id = this.formAttribute[i].value_id
                  this.attribute[index].unit_name = this.formAttribute[i].unit_name
                  // this.attribute[index].unit_id = this.formAttribute[i].unit_id
                  if(this.formAttribute[i].unit_name!='' && this.attribute[index].unit.length>0){
                    for (let j = 0; j <this.attribute[index].unit.length; j++) {
                      // console.log('object :>> ', this.attribute[index].unit_name);
                      if(this.formAttribute[i].unit_name == this.attribute[index].unit[j].unit_name){
                      this.attribute[index].unit_id =this.attribute[index].unit[j].unit_id
                      }else{
                        this.attribute[index].unit_id=this.formAttribute[i].unit_id
                      }
                    }
                  }
}
}
}
}
}
}
}
</script>

<style>

</style>